import { buildState } from '@briebug/ngrx-auto-entity';
import { createReducer } from '@ngrx/store';
import { ReputationScore } from './reputation-score.model';


export const {
  initialState: initialReputationScoreState,
  selectors: {
    selectAll: allReputationScores,
  },
  actions: {
    load: loadReputationScore,
  }
} = buildState(ReputationScore);

export const reputationScoreReducer = createReducer(initialReputationScoreState);
